// 이미지 에셋 import 및 관리
import logo from "../assets/images/logo.png";
import reviewProfile1 from "../assets/images/review_profile1.jpg";
import reviewProfile2 from "../assets/images/review_profile2.jpg";
import reviewProfile3 from "../assets/images/review_profile3.jpg";
import step1Image from "../assets/images/step1.png";
import step2Image from "../assets/images/step2.png";
import step3Image from "../assets/images/step3.png";
import appStoreImage from "../assets/images/App_Store.png";
import googlePlayImage from "../assets/images/GooglePlay.png";
import qrcodeImage from "../assets/images/qrcode.png";
import mockupBlack from "../assets/images/mockup(black).png";
import mockupWhite from "../assets/images/mockup(white).png";

export const IMAGES = {
  // 로고
  LOGO: "/contents/logo.png",

  // 프로필 이미지들
  REVIEWS: {
    PROFILE_1: "/contents/review_profile1.jpg",
    PROFILE_2: "/contents/review_profile2.jpg",
    PROFILE_3: "/contents/review_profile3.jpg",
  },

  // 프로세스 이미지들
  STEPS: {
    STEP_1: "/contents/step1.png",
    STEP_2: "/contents/step2.png",
    STEP_3: "/contents/step3.png",
  },

  // 앱 관련 이미지들
  APPS: {
    APP_STORE: "/contents/App_Store.png",
    GOOGLE_PLAY: "/contents/GooglePlay.png",
    QR_CODE: "/contents/qrcode.png",
  },

  // 목업 이미지들
  MOCKUPS: {
    BLACK: "/contents/mockup(black).png",
    WHITE: "/contents/mockup(white).png",
  },

  // 히어로 섹션
  HERO_BG: "/contents/hero_img.png",

  // 프로모션 섹션
  PROMO_VIDEO: "/contents/mockup_video.gif",

  // CTA 섹션
  CTA_BG: "/contents/b2b.jpg",

  // PDF 샘플
  PDF_SAMPLE: "/contents/sample.pdf",
};

// Public 디렉토리 파일들 (절대 경로)
export const PUBLIC_ASSETS = {
  // 대용량 배경 이미지들
  BACKGROUNDS: {
    HERO: "/contents/hero_img.png",
    CTA: "/contents/b2b.jpg",
  },

  // 비디오 파일들
  VIDEOS: {
    HERO_MP4: "/contents/hero_video.mp4",
    HERO_GIF: "/contents/hero_video.gif",
    MOCKUP_MP4: "/contents/mockup_video.mp4",
    MOCKUP_GIF: "/contents/mockup_video.gif",
  },

  // PDF 및 문서들
  DOCUMENTS: {
    SAMPLE_PDF: "/contents/sample.pdf",
  },

  // 모달용 스토리 이미지들 (동적 로드)
  STORIES: {
    STORY_1: "/contents/story1.png",
    STORY_2: "/contents/story2.png",
    STORY_3: "/contents/story3.png",
  },

  // 기타 공개 에셋들
  ICON: "/contents/icon.gif",
  HERO_VIDEO: "/contents/hero_video.gif",
  HERO_VIDEO_MP4: "/contents/hero_video.mp4",
  MOCKUP_VIDEO: "/contents/mockup_video.gif",
  MOCKUP_VIDEO_MP4: "/contents/mockup_video.mp4",
};
